import { NotificationsService } from 'data/services';
import { NotificationsServiceInterface } from 'domain/services';
import { makeRemoteGetDirectorNotifications } from 'main/factories/usecases/notifications/remote-get-director-notifications-factory';
import { makeRemoteMarkDirectorNotificationAsRead } from 'main/factories/usecases/notifications/remote-mark-director-notification-as-read-factory';

export const makeNotificationsService = (): NotificationsServiceInterface => {
  return new NotificationsService(
    makeRemoteGetDirectorNotifications(),
    makeRemoteMarkDirectorNotificationAsRead(),
  );
};
